// Mirrors bbs-api src/Helpers/EmailAddressList.cs; keep the two in step.
//
// Recipient fields accept addresses separated by ',' or ';', each either bare
// ("rmenon@alec.ae") or with an Outlook-style display name
// ("Rajesh Menon <rmenon@alec.ae>").

export const INVALID_EMAIL_MESSAGE = "Please enter a valid email address.";

const ADDRESS_PATTERN =
  /^[A-Za-z0-9._%+'-]+@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/;
const NAMED_ADDRESS_PATTERN = /^[^<>]*<([^<>]*)>$/;

// Splits on ',' and ';' outside quotes and angle brackets, dropping empty entries.
function splitEntries(value: string): string[] {
  const entries: string[] = [];
  let current = "";
  let inQuotes = false;
  let inAngle = false;

  for (const c of value) {
    if (c === '"') inQuotes = !inQuotes;
    else if (c === "<" && !inQuotes) inAngle = true;
    else if (c === ">" && !inQuotes) inAngle = false;
    else if ((c === "," || c === ";") && !inQuotes && !inAngle) {
      if (current.trim()) entries.push(current.trim());
      current = "";
      continue;
    }
    current += c;
  }

  if (current.trim()) entries.push(current.trim());
  return entries;
}

function isValidEntry(entry: string): boolean {
  const named = NAMED_ADDRESS_PATTERN.exec(entry);
  const address = named ? named[1].trim() : entry;

  return (
    ADDRESS_PATTERN.test(address) &&
    !address.includes("..") &&
    !address.startsWith(".") &&
    !address.includes(".@")
  );
}

export function parseEmailList(value: string | null | undefined): {
  count: number;
  invalid: string[];
} {
  const entries = splitEntries(value ?? "");
  return {
    count: entries.length,
    invalid: entries.filter((entry) => !isValidEntry(entry)),
  };
}
